import moment from 'moment';
import React, { Component }  from 'react';
import { withRouter } from 'react-router';
import { copyrightText } from '../../../../../UHFAgenCDN';

class Footer extends Component {
  
  render() {
    return (
      <div>    
        
                    
      <p style={{textAlign:'center'}}>{copyrightText()}</p>
                  
      </div>

    )
  }


}
export default withRouter(Footer);